// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Lm-z","tupacHeader":"Mm-z","tupacHeader2":"Nm-z","tupacMenu":"Om-z","tupacMenu2":"Pm-z","tupacMain":"Qm-z","tupacMain2":"Rm-z"};